<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Hvad betyder det?</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <ul>
    <li>Ordren vil blive vist for dig under "Mine opfølgninger / Ordrer".</li>
    <li>Dine kollegaer vil ikke kunne se ordren på listen med mindre de sætter filtret "Vis parkéret" til.</li>
    <li>Ordren vil først blive normalt synlig for dine kollegaer igen, når du fjerner den fra "Mine opfølgninger".</li>
  </ul>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
</div>
